import { render, staticRenderFns } from "./FailureEmailTab.vue?vue&type=template&id=de1d5370&scoped=true&"
import script from "./FailureEmailTab.vue?vue&type=script&lang=js&"
export * from "./FailureEmailTab.vue?vue&type=script&lang=js&"
import style0 from "./FailureEmailTab.vue?vue&type=style&index=0&id=de1d5370&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1d5370",
  null
  
)

export default component.exports